import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";

interface IHeaderProps {
  handleInfoClick: () => void;
}

const Header = ({ handleInfoClick }: IHeaderProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <div className={styles.headerRow}>
        <div className={styles.titleContainer}>
          <h3 className={styles.title}>{t("lbl_settlement_details_title")}</h3>
          <img
            src="/assets/images/svg/info.svg"
            alt=""
            onClick={handleInfoClick}
          />
        </div>

        <p
          onClick={() => {
            navigate(-1);
          }}
          className={styles.cancel}>
          {t("lbl_cancel")}
        </p>
      </div>
      <div className={styles.divider} />
    </div>
  );
};

export default Header;
